<button mat-icon-button [matMenuTriggerFor]="lms">
    <mat-icon>keyboard_arrow_down</mat-icon>
</button>

<mat-menu #lms="matMenu">
    <ng-container *ngIf="!!allLLmsList?.length">
        <button
            mat-menu-item
            class="lms-item"
            *ngFor="let item of allLLmsList"
            [disabled]="!item.enabled"
            (click)="selectModel(item)"
            [class.selected]="item.value === model?.value"
            [class.llm-divider]="item.divider"
        >
            <!-- <mat-checkbox
                *ngIf="multipleCheck"
                class="check-advanced"
                (click)="$event.stopPropagation()"
                [checked]="item.value === model?.value"
                [indeterminate]="false"
            ></mat-checkbox> -->
            <span>{{ item.name }}</span>
        </button>
    </ng-container>
</mat-menu>
